
export const logUser = () => {
    return {
        type: "LOGIN_USER",
    }
}

export const loginSuccess = user => {
    return {
        type: "LOGIN_SUCCESS",
        payload: user,
    }
}

